var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDapplets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 20,
    width: 80,
    height: 80,
    rx: 8,
    fill: "#27292E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104 67.6667C104 66.2 102.8 65 101.333 65H96V70.3333H101.333C102.8 70.3333 104 69.1333 104 67.6667Z",
    fill: "#A6B7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.333 75.6665H96V80.9998H101.333C102.8 80.9998 104 79.7998 104 78.3332C104 76.8665 102.8 75.6665 101.333 75.6665Z",
    fill: "#A6B7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6667 62.3335H85.3334C82.4001 62.3335 80.0001 64.7335 80.0001 67.6668H77.3334C75.8667 67.6668 74.6667 68.8668 74.6667 70.3335V75.6668C74.6667 77.1335 75.8667 78.3335 77.3334 78.3335H80.0001C80.0001 81.2668 82.4001 83.6668 85.3334 83.6668H90.6667C92.1334 83.6668 93.3334 82.4668 93.3334 81.0002V65.0002C93.3334 63.5335 92.1334 62.3335 90.6667 62.3335Z",
    fill: "#A6B7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3333 65C61.3333 62.0667 63.7333 59.6667 66.6667 59.6667H70.6667C75.8133 59.6667 80 55.48 80 50.3333C80 45.1867 75.8133 41 70.6667 41H61.3333C59.8667 41 58.6667 42.2 58.6667 43.6667C58.6667 45.1333 59.8667 46.3333 61.3333 46.3333H70.6667C72.88 46.3333 74.6667 48.12 74.6667 50.3333C74.6667 52.5467 72.88 54.3333 70.6667 54.3333H66.6667C60.7733 54.3333 56 59.1067 56 65C56 70.8933 60.7733 75.6667 66.6667 75.6667H72V70.3333H66.6667C63.7333 70.3333 61.3333 67.9333 61.3333 65Z",
    fill: "#A6B7FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 160,
    height: 160,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2775 0 0 0 0 0.225 0 0 0 0 0.6 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDapplets);
export default __webpack_public_path__ + "static/media/Dapplets.87b1bd69d7c5ba60b3ae6cce7ee21b05.svg";
export { ForwardRef as ReactComponent };